{
  "altitude": {
    "displayName": "Altitude",
    "unitLabel": {
      "metric": "m",
      "us": "ft"
    }
  },
  "applicationRateEstimatedMm": {
    "displayName": "Application"
  },
  "applicationRateReportsMm": {
    "displayName": "Application",
    "unitLabel": {
      "metric": "mm",
      "us": "in"
    }
  },
  "calibrationIntercept": {
    "displayName": "Calibration Intercept"
  },
  "calibrationSlope": {
    "displayName": "Calibration Slope"
  },
  "configurationId": {
    "displayName": "Configuration ID"
  },
  "currentPercentage": {
    "displayName": "Current Percentage"
  },
  "deviceFunctionCall": {
    "displayName": "Device function call"
  },
  "deviceFunctionCallId": {
    "displayName": "causeId"
  },
  "direction": {
    "displayName": "Direction"
  },
  "diameterMm": {
    "displayName": "Wheel Diameter",
    "instructions": "Measure the diameter (widest distance between two sides of the wheel).",
    "unitLabel": {
      "metric": "mm",
      "us": "in"
    }
  },
  "distanceObservedMm": {
    "displayName": "Distance",
    "unitLabel": {
      "metric": "m",
      "us": "ft"
    }
  },
  "endGun": {
    "displayName": "End Gun"
  },
  "flowRateEstimatedLpm": {
    "displayName": "Flow Rate",
    "unitLabel": {
      "metric": "l/min",
      "us": "gal/min"
    }
  },
  "gpsType": {
    "displayName": "GPS Chip Model"
  },
  "hasDirectionControl": {
    "displayName": "Has Direction Control",
    "description": "Whether the pivot controller can change direction (clockwise/counterclockwise)"
  },
  "hasEndGun": {
    "displayName": "Has End Gun",
    "description": "Whether the pivot has an end gun that can be controlled"
  },
  "hasSpeedControl": {
    "displayName": "Has Speed Control",
    "description": "Whether the pivot speed can be adjusted"
  },
  "hasWetDryControl": {
    "displayName": "Has Wet/Dry Control",
    "description": "Whether the pivot pump can be turned on/off"
  },
  "heading": {
    "displayName": "Heading",
    "unitLabel": "°"
  },
  "hoseWheelMmPerMagnet": {
    "displayName": "Distance Per Magnet",
    "description": "The distance of hose travel for each magnet reading on the hose wheel sensor.",
    "unitLabel": {
      "metric": "mm",
      "us": "in"
    }
  },
  "hoseDiameterMm": {
    "displayName": "Hose Diameter",
    "images": {
      "hose_diameter.png": {
        "caption": "Make sure to measure the hose at its widest point."
      }
    },
    "instructions": {
      "1": "As precisely as possible, measure the diameter of the reel's hose.",
      "2": "Make sure to measure the hose at its widest point. In the image below, the farmer uses his index fingers to find the widest point of the hose, and uses the tape measurer to line."
    },
    "unitLabel": {
      "metric": "mm",
      "us": "inches"
    }
  },
  "i2cAddress": {
    "displayName": "Internal i2c bus address"
  },
  "installedOrientation": {
    "displayName": "Installed Orientation"
  },
  "internalSoc": {
    "displayName": "Battery Internal Soc",
    "unitLabel": "%"
  },
  "ioPin": {
    "displayName": "IO Pin"
  },
  "linearSlopeM": {
    "displayName": "Linear slope calibration 'a' (ax + b)"
  },
  "linearInterceptM": {
    "displayName": "Linear intercept calibration 'b' (ax + b)"
  },
  "linearSpeedMmHMax": {
    "displayName": "Maximum Retract Speed",
    "unitLabel": {
      "metric": "m/hr",
      "us": "ft/hr"
    }
  },
  "linearSpeedMmHMin": {
    "displayName": "Minimum Retract Speed",
    "unitLabel": {
      "metric": "m/hr",
      "us": "ft/hr"
    }
  },
  "location": {
    "displayName": "Location"
  },
  "maxTrackingPercentage": {
    "displayName": "Max Tracking Percentage"
  },
  "measuredM": {
    "displayName": "Measured Depth",
    "unitLabel": {
      "metric": "M",
      "us": "ft"
    }
  },
  "milliRpmAvg": {
    "displayName": "RPM",
    "unitLabel": "RPM"
  },
  "milliRpmFast": {
    "displayName": "Speed Threshold (Upper)",
    "unitLabel": "RPM"
  },
  "milliRpmSlow": {
    "displayName": "Speed Threshold (Lower)",
    "unitLabel": "RPM"
  },
  "minTrackingPercentage": {
    "displayName": "Min Tracking Percentage"
  },
  "mlPerPulse": {
    "displayName": "Volume Per Pulse",
    "unitLabel": {
      "metric": {
        "long": "Liters",
        "short": "L"
      },
      "us": "gal"
    }
  },
  "sensorPortMode": {
    "displayName": "Sensor Port Mode",
    "values": {
      "CURRENT_LOOP": "4-20ma",
      "SCALED_VOLTAGE": "VOLTAGE"
    },
    "description": "Sensor ports may be configured to accept scaled voltage- or 4-20ma-type signals. If you're unsure, choose Voltage."
  },
  "measurementType": {
    "displayName": "Measurement Type",
    "values": {
      "PULSE": "PULSE",
      "ANALOG": "ANALOG (ax + b)"
    },
    "description": "Determines whether the sensor counts pulses or reads an analog signal to determine flow. If you're unsure, choose PULSE."
  },
  "normalThresholdLpm": {
    "displayName": "Normal Threshold",
    "unitLabel": {
      "metric": {
        "long": "Liters per Minute",
        "short": "L/m"
      },
      "us": "gal/m"
    },
    "description": "Flow rates below this threshold will be labelled \"Not Flowing\""
  },
  "overThresholdLpm": {
    "displayName": "Over Threshold",
    "unitLabel": {
      "metric": {
        "long": "Liters per Minute",
        "short": "L/m"
      },
      "us": "gal/m"
    },
    "description": "Flow rates above this threshold will be labelled \"Flow OVER\""
  },
  "slope": {
    "displayName": "Analog Calibration Slope",
    "description": "Linear calibration slope (a) parameter for ANALOG measurement type. Set to 1 for Pulse-type meters."
  },
  "intercept": {
    "displayName": "Analog Calibration Intercept",
    "description": "Linear calibration intercept (b) parameter for ANALOG measurement type. Set to 0 for Pulse-type meters."
  },
  "nMagnets": {
    "description": "How many magnets are installed on the spool? For reels, this should be between 8 and 16",
    "displayName": "Number of Installed Magnets",
    "images": {
      "magnet_installation_positions.png": {
        "caption": "Standard 16-magnet installation"
      }
    },
    "optionLabel": "Magnets"
  },
  "nNozzles": {
    "description": "How many nozzles does the reel use to deliver water?",
    "displayName": "Number of Nozzles",
    "images": {
      "irrigation_boom.png": {
        "caption": "A boom with 12 nozzles."
      },
      "irrigation_gun.png": {
        "caption": "A gun reel with a single nozzle."
      }
    }
  },
  "normalThresholdM": {
    "displayName": "Normal Threshold",
    "unitLabel": {
      "metric": {
        "long": "Meters",
        "short": "M"
      },
      "us": {
        "long": "Feet",
        "short": "ft"
      }
    }
  },
  "highThresholdM": {
    "displayName": "High Threshold",
    "unitLabel": {
      "metric": {
        "long": "Meters",
        "short": "M"
      },
      "us": {
        "long": "Feet",
        "short": "ft"
      }
    }
  },
  "overThresholdM": {
    "displayName": "Over Threshold",
    "unitLabel": {
      "metric": {
        "long": "Meters",
        "short": "M"
      },
      "us": {
        "long": "Feet",
        "short": "ft"
      }
    }
  },
  "nSats": {
    "displayName": "Signal Quality"
  },
  "nWrapsOuterLayer": {
    "description": "When the hose is fully-wound around the spool, how many wraps are visible on the outermost layer?",
    "displayName": "Number of Outer Layer Wraps",
    "images": {
      "reel_outer_hose_wraps.png": {
        "caption": "A reel with 9 outer layer wraps.\n\nNote that only the hose wraps to the left and right of the 9th wrap are not counted, even though they are visible because they are not on the outer layer."
      }
    }
  },
  "normalThreshold": {
    "displayName": "Normal Threshold",
    "unitLabel": {
      "metric": {
        "long": "Celsius",
        "short": "C"
      },
      "us": {
        "long": "Fahrenheit",
        "short": "F"
      }
    }
  },
  "overThreshold": {
    "displayName": "Over Threshold",
    "unitLabel": {
      "metric": {
        "long": "Celsius",
        "short": "C"
      },
      "us": {
        "long": "Fahrenheit",
        "short": "F"
      }
    }
  },
  "flowRateOverrideLpm": {
    "displayName": "Flow Rate Override",
    "description": "When set, this measured flow rate is used directly for irrigation history calculations instead of estimating from nozzle diameter and pressure. Leave blank to use the nozzle-based estimate.",
    "instructionsWithUnitLabel": "Enter the measured flow rate in {{unitLabel}}, or leave blank to fall back to the nozzle-diameter estimate.",
    "unitLabel": {
      "metric": {
        "long": "liters per minute",
        "short": "L/min"
      },
      "us": {
        "long": "gallons per minute",
        "short": "gal/min"
      }
    }
  },
  "nozzleDiameterMm": {
    "displayName": "Nozzle Diameter",
    "images": {
      "nozzle_diameter.png": {
        "altText": "Annotated photo illustrating the measurement trajectory of the nozzle diameter measurement.",
        "caption": "Make sure to measure the nozzle opening at its widest point."
      }
    },
    "instructionsWithUnitLabel": "Measure the inner width of the nozzle in {{unitLabel}}",
    "note": "Make sure to measure the nozzle opening at its widest point.",
    "unitLabel": {
      "metric": {
        "long": "millimeters",
        "short": "mm"
      },
      "us": {
        "long": "inches",
        "short": "in"
      }
    }
  },
  "otaEnabled": {
    "displayName": "O.T.A. Enabled"
  },
  "outerHoseWrapRadiusMm": {
    "description": "The outer hose wrap radius is the distance from the center of the spool to the outside edge of the hose when it is fully wrapped.",
    "displayName": "Outer Hose Wrap Radius",
    "images": {
      "reel_outer_hose_wraps.png": {
        "altText": "Measurement diagram for outer hose wrap radius."
      }
    },
    "instructions": {
      "introduction": "To determine this measurement, do one of the following:",
      "options": {
        "1": "If you can easily determine where the outer edge of the hose would fall on the outward-facing side of the spool (see picture below), measure the distance between the center of the spool's axis and the relative location of the edge of the hose.",
        "2": "Alernatively, you can look inside the spool and measure the distance from the spool's outside edge to the beginning of the hose. Subtract this distance from the distance between the spool's edge and the spool's axis."
      }
    },
    "unitLabel": {
      "metric": "mm",
      "us": "in"
    }
  },
  "pidDerivativeCoeff": {
    "displayName": "PID Derivative Coefficient"
  },
  "pidGainCoeff": {
    "displayName": "PID Gain Coefficient"
  },
  "pidIntegralCoeff": {
    "displayName": "PID Integral Coefficient"
  },
  "pidSensorSetpoint": {
    "displayName": "PID Sensor Setpoint"
  },
  "pidMeasurementType": {
    "displayName": "PID Measurement Type"
  },
  "pivotRadiusMeters": {
    "displayName": "Pivot Radius",
    "unitLabel": {
      "metric": "Meters",
      "us": "Feet"
    }
  },
  "pressureObservedKpa": {
    "displayName": "Pressure",
    "unitLabel": {
      "metric": "kPa",
      "us": "psi"
    }
  },
  "pressureReportsKpa": {
    "displayName": "Pressure",
    "unitLabel": {
      "metric": "kPa",
      "us": "psi"
    }
  },
  "rampSecondsRemaining": {
    "displayName": "Remaining Seconds"
  },
  "rampSecondsTotal": {
    "displayName": "Total Seconds"
  },
  "rateLpmAvg": {
    "displayName": "Flow Rate Avg",
    "unitLabel": {
      "metric": "l/min",
      "us": "gal/min"
    }
  },
  "rateLpmMax": {
    "displayName": "Flow Rate Max",
    "unitLabel": {
      "metric": "l/min",
      "us": "gal/min"
    }
  },
  "rateLpmMin": {
    "displayName": "Flow Rate Min",
    "unitLabel": {
      "metric": "l/min",
      "us": "gal/min"
    }
  },
  "readingCelsius": {
    "displayName": "Temperature",
    "unitLabel": {
      "metric": "°C",
      "us": "°F"
    }
  },
  "readingKpa": {
    "displayName": "Pressure",
    "unitLabel": {
      "metric": "kPa",
      "us": "psi"
    }
  },
  "reportingPeriodEndDt": {
    "displayName": "Reporting Period End"
  },
  "reportingPeriodStartDt": {
    "displayName": "Reporting Period Start"
  },
  "relativePercentage": {
    "displayName": "Relative Percentage (%)",
    "unitLabel": {
      "metric": "%",
      "us": "%"
    }
  },
  "runDistanceMmCurrent": {
    "displayName": "Distance Remaining",
    "unitLabel": {
      "metric": "m",
      "us": "ft"
    }
  },
  "runDistanceMmElapsed": {
    "displayName": "Distance Elapsed",
    "unitLabel": {
      "metric": "m",
      "us": "ft"
    }
  },
  "runDistanceMmMax": {
    "displayName": "Distance Extended",
    "unitLabel": {
      "metric": "m",
      "us": "ft"
    }
  },
  "runMagnetCountCurrent": {
    "displayName": "Magnet Count Current"
  },
  "runMagnetCountMax": {
    "displayName": "Magnet Count Max"
  },
  "runSpeedMmpm": {
    "displayName": "Run Speed",
    "unitLabel": {
      "metric": "m/hr",
      "us": "ft/hr"
    }
  },
  "scheduledDeviceAction": {
    "displayName": "Scheduled device action"
  },
  "sensorModelId": {
    "displayName": "Sensor Model"
  },
  "sensorPort": {
    "description": "Reel, Pressure, Wheel, Flow, and Depth sensors can each be installed on one of the sensor ports on a FarmHQ device (generations FC2 and TC3 only).",
    "displayName": "Sensor Port",
    "displayNameWithVal": "Port {{val}}",
    "fieldLabelWithSensorName": "{{sensorName}} Sensor Port",
    "images": {
      "enclosure_front.png": {
        "caption": "Sensor ports 1 (middle left) and 2 (middle right) on a FarmHQ FC2 enclosure."
      }
    },
    "values": {
      "port-1": "Port 1",
      "port-2": "Port 2"
    }
  },
  "sensorPriority": {
    "displayName": "Sensor Priority"
  },
  "sensorTriggeredUpdate": {
    "displayName": "Sensor Triggered Update"
  },
  "signalQuality": {
    "displayName": "Signal Quality"
  },
  "signalStrength": {
    "displayName": "Signal Strength"
  },
  "speedMillirpm": {
    "displayName": "Rotational Speed",
    "unitLabel": "RPM"
  },
  "speedMmpm": {
    "displayName": "Speed",
    "unitLabel": {
      "metric": "m/hr",
      "us": "ft/hr"
    }
  },
  "speedObservedMmpm": {
    "displayName": "Speed",
    "unitLabel": {
      "metric": "m/hr",
      "us": "ft/hr"
    }
  },
  "speedReportsMmpm": {
    "displayName": "Speed",
    "unitLabel": {
      "metric": "m/hr",
      "us": "ft/hr"
    }
  },
  "speedPercent": {
    "displayName": "Speed",
    "unitLabel": "%"
  },
  "speedMeasurementMethod": {
    "displayName": "Speed Measurement Method",
    "description": "Choose how reel speed is measured. 'Spool Rotation' calculates speed from spool geometry. 'Hose Wheel' measures the hose directly as it passes a sensor wheel.",
    "values": {
      "spool_rotation": "Spool Rotation",
      "hose_wheel": "Hose Wheel"
    }
  },
  "applicationType": {
    "displayName": "Application Type",
    "description": "What this reel applies to the field. Each reel run is annotated with this type. Defaults to water.",
    "values": {
      "water": "Water",
      "manure": "Manure",
      "other": "Other"
    }
  },
  "sprinklerType": {
    "description": "Choosing 'Gun' will add semicircular endcaps to the swaths on the Device Status Map and Field Irrigation History page.",
    "displayName": "Sprinkler Type",
    "values": {
      "boom": "Boom",
      "gun": "Gun"
    }
  },
  "startRampPercentage": {
    "displayName": "Start Percentage"
  },
  "stateCurrent": {
    "displayName": "State Current"
  },
  "stateCurrentInitDt": {
    "displayName": "Last Status Change"
  },
  "statePrevious": {
    "displayName": "Previous Status"
  },
  "statePreviousInitDt": {
    "displayName": "Previous Status Change"
  },
  "stoppedTimeoutMs": {
    "displayName": "Wheel Stopped Timeout",
    "description": "How long the device waits without detecting wheel movement before reporting the wheel as stopped.",
    "unitLabel": "min"
  },
  "swathWidthMm": {
    "descriptionWithUnitLabel": "An estimate for the width of a row in {{unitLabel}}. For gun-reels, this also double the distance water is sprayed by the gun.",
    "displayName": "Swath Width",
    "placeholder": "Enter the width of the swath",
    "unitLabel": {
      "metric": "m",
      "us": "ft"
    }
  },
  "switchType": {
    "helpBodyText": "The default switch setting indicates whether the switch is normally open or normally closed.\n\n If you are unsure, please contact FarmHQ support.",
    "displayName": "Default Switch Setting",
    "values": {
      "C": "closed",
      "O": "open"
    }
  },
  "targetRampPercentage": {
    "displayName": "Target Percentage"
  },
  "threshold": {
    "displayName": "Threshold",
    "unitLabel": {
      "metric": "kPa",
      "us": "psi"
    }
  },
  "thresholdBufferM": {
    "displayName": "Buffer",
    "descriptionWithUnitLabel": "Provided wiggle room on thresholds to avoid triggering frequent state changes. With no buffer, any small level changes around a threshold will trigger the device to send an event (and you to be notified, triggers to occur, etc.).",
    "unitLabel": {
      "metric": {
        "long": "Meters",
        "short": "m"
      },
      "us": {
        "long": "Feet",
        "short": "ft"
      }
    }
  },
  "thresholdPsiLower": {
    "descriptionWithValue": "Anything below {{value}} is too low.",
    "displayName": "Lower Threshold",
    "unitLabel": {
      "metric": "kPa",
      "us": "psi"
    }
  },
  "thresholdPsiUpper": {
    "descriptionWithValue": "Anything above {{value}} is too high.",
    "displayName": "Upper Threshold",
    "unitLabel": {
      "metric": "kPa",
      "us": "psi"
    }
  },
  "voltageChangeMvPerHour": {
    "displayName": "Voltage Change"
  },
  "voltageIntercept": {
    "displayName": "Voltage Intercept"
  },
  "voltageMv": {
    "displayName": "Voltage",
    "unitLabel": "V"
  },
  "voltageSlope": {
    "displayName": "Voltage Slope"
  },
  "voltageThresholdLowMv": {
    "displayName": "Voltage Threshold Lower",
    "unitLabel": "Volts"
  },
  "volumeLFinal": {
    "displayName": "Volume Final",
    "unitLabel": {
      "metric": "l",
      "us": "gal"
    }
  },
  "volumeLInitial": {
    "displayName": "Volume Initial",
    "unitLabel": {
      "metric": "l",
      "us": "gal"
    }
  },
  "volumeLTotal": {
    "displayName": "Volume Total",
    "unitLabel": {
      "metric": "l",
      "us": "gal"
    }
  },
  "wetDry": {
    "displayName": "Pump State"
  },
  "widthMm": {
    "displayName": "Spool Width",
    "images": {
      "reel_width.png": {
        "caption": "Reel width diagrammed."
      }
    },
    "instructions": "Measure the distance between the walls of the spool.",
    "unitLabel": {
      "metric": "mm",
      "us": "in"
    }
  }
}
